'use client';

import { useSearchParams } from 'next/navigation';

export const useQueryParams = () => {
  const searchParams = useSearchParams();

  const getParam = (key: string): string => searchParams?.get(key) ?? '';

  const getBool = (key: string, defaultValue: boolean = false): boolean => {
    const value = searchParams?.get(key);
    return value === null ? defaultValue : value === 'true';
  };

  return {
    bookingId: getParam('bookingId'),
    dinerId: getParam('dinerId'),
    modified: getBool('modified'),
    notAcceptingBooking: getBool('notAcceptingBooking', true),
    phone: getParam('phone'),
    shouldRequestConfirm: getBool('should_request_confirm'),
    slug: getParam('slug'),
    withAccountDetails: getBool('withAccountDetails', false)
  };
};
